<template>
    <div class="content">
        <p class="title">招聘公告详情</p>
        <div class="infoContent">
            <p class="tit">{{article.title}}</p>
            <p class="time">{{article.create_time_str}}</p>
            <div class="article" v-html="article.content"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
      return {
        id:'',
        article:[]
      }
    },
    created(){
        this.id=this.$route.query.id
        this.getInfo()
    },
    methods:{
        getInfo(){
            this.$axios
            .get(this.$api.getinfo,
                {id:this.id})
            .then((res) => {
                let data=res.result
                this.article=data
            });
        }
    }
}
</script>

<style lang="less" scoped>
    .content{
        width: 1280px;
        min-height: calc(100vh - 230px);
        margin: 0 auto;
        padding: 30px 0;
        .title{
            line-height: 26px;
            font-size: 16px;
            color: #666;
            font-weight: 400;
            margin-bottom: 25px;
        }
        .infoContent{
            .tit{
                line-height: 62px;
                text-align: center;
                font-size: 38px;
                font-weight: bold;
                color: #333;
            }
            .time{
                width: 100%;
                line-height: 56px;
                text-align: center;
                font-size: 16px;
                color: #999;
                border-bottom: 1px solid #E4E7ED;
            }
            .article{
                line-height: 30px;
                padding: 15px 30px;
                font-size: 16px;
            }
        }
    }
    
    

</style>